import OtherUsefulApps from "@components/OtherAppsPage/OtherUsefulApps"
import styles from "./OtherAppsPage.module.css"
import NavigationsPage from "@containers/NavigationsPage/NavigationPage"
import PageWrapper from "@components/Common/PageWrapper"

const OtherAppsPage = () => {
  return (
    <>
      <NavigationsPage>
        <PageWrapper className={styles.otherAppsPage}>
          <OtherUsefulApps />
        </PageWrapper>
      </NavigationsPage>
    </>
  )
}

export default OtherAppsPage
